export const getContactInfoLink = (links: Array<any>): string => {
  return links?.length > 0 && links[0]?.links?.find((link: any) => link?.label === "Contact & Support")?.link;
};
